<template>

  <v-container>

    <h1 class="py-10">{{ $t("Select an account") }}</h1>

    <Companies />

  </v-container>

</template>

<script>

// import { mapGetters } from "vuex";
import Companies from '@/components/companies/Companies' ;

export default {
  name: "Reporters",

//   computed: {

//     ...mapGetters({
//       user: 'user/current'
//     })

//   },
  components: {
    Companies,
  },
//   data () {
//     return {
//       contest: 'loading'
//     }
//   },
  methods: {

  },
  created() {

  }

};
</script>
